/*
 *
 * GenericModal
 *
 * @version 1.0.0
 * @author Pietro Bertuccelli
 * @since 09-Sep-2024
*/

import InformativeISPModal from './InformativeIspModalContainer'

export default InformativeISPModal
